import systemMessageApi from '@/apis/systemMessage';

export const actions = {
  async getSystemMessages({ commit }) {
    const result = await systemMessageApi.getSystemMessages();
    commit('setSystemMessages', result);
  },
  async getSystemMessagesByClientId({ commit }, clientId) {
    const result = await systemMessageApi.getSystemMessagesByClientId(clientId);
    commit('setSystemMessages', result);
  },
  async markSystemMessageAsRead({ commit }, { messageId, readAt, clientId }) {
    await systemMessageApi.markSystemMessageAsRead({ messageId, readAt, clientId });
  },
};
